<script setup lang="ts">
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

import Badge from "primevue/badge";

import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

interface IProps {
  badgeValue?: number;
}

interface IEmits {
  (e: "clear"): void;
  (e: "click"): void;
}

const props = defineProps<IProps>();
const emits = defineEmits<IEmits>();

const { t, k } = useTypedIntl();
</script>

<template>
  <div
    class="text-white rounded-full overflow-clip flex"
    :data-test-id="DATA_TEST_IDS.views.dashboard.selectPerimeter.button"
  >
    <HospitalityButton
      class="!pl-4 !pr-2 !py-2 !rounded-r-none"
      size="sm"
      @click="emits('click')"
    >
      <Badge
        v-if="props.badgeValue"
        :pt="{
          root: {
            class: '!bg-white !text-brand mr-2',
          },
        }"
        :value="props.badgeValue"
      />
      <h5>
        {{ t(k.data.dashboard.selectPerimeter.selected) }}
      </h5>
    </HospitalityButton>
    <HospitalityButton
      class="!pr-4 !pl-2 !py-2 !rounded-l-none"
      size="sm"
      @click="emits('clear')"
    >
      <i class="pi pi-times" />
    </HospitalityButton>
  </div>
</template>
